<script src="http://res.wx.qq.com/open/js/jweixin-1.6.0.js"></script>
<template>
<div style="width: 42% !important;margin-left: 29%;">
  <img src="img/order.jpg" style="width: 60%;margin-left: 20%;margin-top: 30px;"/>
  <!-- <img :src="EWMUrl" style="width: 60%;margin-left: 20%;margin-top: 30px;"/> -->
  <div style="text-align: center;font-size: 30px;margin-top: 30px;">打开微信扫一扫，查看订单</div>
</div>
</template>
<script>
import wx from 'weixin-js-sdk'
import html2canvas from 'html2canvas'
import QRCode from 'qrcode'
export default {
  name: 'orderList',
  data () {
    return {
      requestHeadUrl: 'https://zhenqing.kequbang.com',
      // requestHeadUrl: 'http://localhost:8122',
      // requestHeadUrl22: 'http://localhost:8122',
      // requestHeadUrl22: 'https://zhenqing.kequbang.com',
      // requestHeadUrl22: 'http://192.168.137.1:8122',
      isOpenVipModular: false,
      showModal: false, // 是否展示弹窗
      EWMUrl: '',
      payPrice: '',
      showTp: false
    }
  },
  created () {
    // 用 canvas 对象和邀请链接生成二维码，并将生成的二维码转为 base64
    // console.log("12121212")
    // console.log(this.$root.codeUrl)
    // this.onLoad() 
  },
  methods: {
    onLoad: function () {
      // this.navigateToMiniProgram(JSON.stringify(payParam))
      //9d03442a91c345709dcbcd85daab9cc4
      const thisObj = this
      thisObj.$api.get(thisObj.requestHeadUrl + '/p/order/appCode', {}).then(res => {
        this.EWMUrl = 'data:image/jpeg;base64,' + res
        this.showTp = true
        return
        let canvas = document.createElement('canvas')
        QRCode.toCanvas(canvas, res.openlink, (error) => {
          if (error) {
              console.log(error)
          } else {
            this.EWMUrl = canvas.toDataURL('image/jpeg')
          }
        })
      }).catch(function (error) {
        thisObj.$util.requetServerError(error)
      })
    },
    getLongitudeLatitude() {
      var that = this
      //如果该对象存在，那么地理位置服务可用。
      if ('geolocation' in navigator) {
        /* 地理位置服务可用 */
        var options = {
          enableHighAccuracy: true, //布尔值，表示系统是否使用最高精度来表示结果，注意，这会导致较慢的响应时间或者增加电量消耗（比如对于支持gps的移动设备来说）。如果值为false ，设备会通过更快响应以及/或者使用更少的电量等方法来尽可能的节约资源。默认值fasle
          timeout: 5000, //它表明的是设备必须在多长时间（单位毫秒）内返回一个位置。默认直到获取到位置才会返回值。
          maximumAge: 0 //表明可以返回多长时间（即最长年龄，单位毫秒）内的可获取的缓存位置。如果设置为 0, 说明设备不能使用一个缓存位置，而且必须去获取一个真实的当前位置。默认0
        }
        function success(position) {
          
          //position.coords (只读) 返回一个定义了当前位置的Coordinates对象。
          //position.timestamp (只读) 返回一个时间戳DOMTimeStamp， 这个时间戳表示获取到的位置的时间。
          var lat = position.coords.latitude //当前位置的纬度
          var lon = position.coords.longitude //当前位置精度
          that.lat = lat
          that.lon = lon
          that.getShops()
          // alert(lat + "A233A" + lng)
        }
        function error(err) {
          console.log(err)
          var errorType = ['您拒绝共享位置信息', '获取不到位置信息', '获取位置信息超时']
          console.log(errorType[err.code - 1])
          // alert(errorType[err.code - 1])
          that.getShops()
        }
 
        navigator.geolocation.getCurrentPosition(success, error, options)
      } else {
        /* 地理位置服务不可用 */
        console.log('无法获取您的位置，请检查定位是否开启或刷新重试')
      }
    },
    getShops() {
      const thisObj = this
      thisObj.$api.get(thisObj.requestHeadUrl + '/group/shop/getAllShopsByGoods?goodsId='+thisObj.info.id, {}).then(res => {
        // console.log(res)
        thisObj.shopList = res
        var shopNames = []
        for (const i in res) {
          shopNames.push(res[i].shopName)
        }
        thisObj.columns = shopNames
      }).catch(function (error) {
        thisObj.$util.requetServerError(error)
      })
    },

    goApp() {
      location.href=this.appLink
    },
    tabSelect(e) {
      this.TabCur = e
    },
    // 页面跳转
    pageJump (uri, item) {
      const thisObj = this
      let queryData = {
      }
      thisObj.$router.push({
        path: uri,
        query: queryData
      })
    },
    setTime() {
      var date = new Date() //1. js获取当前时间
      var min = date.getMinutes() //2. 获取当前分钟
      date.setMinutes(min + 10) //3. 设置当前时间+10分钟：把当前分钟数+10后的值重新设置为date对象的分钟数
      var y = date.getFullYear()
      var m = (date.getMonth() + 1) < 10 ? ("0" + (date.getMonth() + 1)) : (date.getMonth() + 1);
      var d = date.getDate() < 10 ? ("0" + date.getDate()) : date.getDate()
      var h = date.getHours() < 10 ? ('0' + date.getHours()) : date.getHours()
      var f = date.getMinutes() < 10 ? ('0' + date.getMinutes()) : date.getMinutes();
      var s = date.getSeconds() < 10 ? ('0' + date.getSeconds()) : date.getSeconds()
      var formatdate = y + '-' + m + '-' + d + " " + h + ":" + f + ":" + s;
      console.log(formatdate)
      this.endDate2 = formatdate
      this.countTime()
    },
    countTime() {
      var that = this;
      var date = new Date();
      var now = date.getTime();
      var endDate = new Date(that.endDate2); //设置截止时间
      var end = endDate.getTime();
      var leftTime = end - now; //时间差
      var d, h, m, s, ms;
      if (leftTime >= 0) {
        d = Math.floor(leftTime / 1000 / 60 / 60 / 24);
        h = Math.floor(leftTime / 1000 / 60 / 60 % 24);
        m = Math.floor(leftTime / 1000 / 60 % 60);
        s = Math.floor(leftTime / 1000 % 60);
        ms = Math.floor(leftTime % 1000);
        ms = ms < 100 ? "0" + ms : ms
        s = s < 10 ? "0" + s : s
        m = m < 10 ? "0" + m : m
        h = h < 10 ? "0" + h : h
        that.countdown = m + ":" + s + "." + ms,
        //递归每秒调用countTime方法，显示动态时间效果
        setTimeout(that.countTime, 100);
      } else {
        console.log('已截止')
        that.countdown = '00:00:00'
      }
    },
    // 页面跳转
    pageJumpCate (uri) {
      const thisObj = this
      let queryData = {
      }
      thisObj.$router.push({
        path: uri,
        query: queryData
      })
    },
    shopChooseShop() {
      this.showShop = true
    },
    commitPCPay () {
      var that = this
      var isLogin = that.$root.isLogin = true
      var wx = require('weixin-js-sdk')
      var href = window.location.href
      var urlConfig = that.requestHeadUrl + '/p/order'
      // var urlConfig = that.requestUrl + '/weixin/get/knowledge/config?fromDevice=h5'
      const thisObj = this
      var postData = {
        code:that.wxCode,
        userName:that.userName,
        userPhone:that.userPhone,
        notes:that.notes,
        skuName:that.values,
        getId:that.getId,
        payType: 2,
        reservationShop: that.reservationShop,
        reservationShopName:that.chooseShop,
        reservationTime: that.chooseDate
      }
      thisObj.$api.post(thisObj.requestHeadUrl22 + '/p/order/payYx', postData).then(result => {
          console.log(result)
          result.codeUrl
      }).catch(function (error) {
        thisObj.$util.requetServerError(error)
      })
    },
  }
}
</script>

<style>
.bg-e {
  background: #eeeeee;
}
.margin-top {
    margin-top: 30px;
}
.grid {
    display: flex;
    flex-wrap: wrap;
}
.justify-between {
    justify-content: space-between;
}
.align-center {
    align-items: center;
}
.text-xxl {
    font-size: 44px;
}
.margin {
    margin: 30px;
}
.half-angle {
    box-shadow: 1rpx 2rpx 18rpx 0rpx rgba(0, 0, 0, 0.12);
    border-radius: 40rpx;
}
.bg-white {
    background-color: var(--white);
    color: var(--darkGray);
}
.padding {
    padding: 30px;
}
.text-cut {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
}
.text-xl2 {
    font-size: 33px;
}
.flex {
    display: flex;
}
.grid.col-2>div {
    width: 50%;
}
.text-orange, .line-orange, .lines-orange {
    color: #f37b1d;
}
.text-center {
    text-align: center;
}
.text-bold {
    font-weight: bold;
}
.text-xl {
    font-size: 36px;
}
.bg-white {
    background-color: #ffffff;
    color: #666666;
}
.padding {
    padding: 30px;
}
.padding-top {
    padding-top: 30px;
}
.b-b {
    border-bottom: 2px solid #CFCFCF;
}
.padding-sm {
    padding: 20px;
}
.flex-wrap {
    flex-wrap: wrap;
}
.flex {
    display: flex;
}
.text-bold {
    font-weight: bold;
}
.text-orange, .line-orange, .lines-orange {
    color: #f37b1d;
}

.on {
  font-size: 36px;
  border-radius: 20px 20px 0 0;
}

.shuxing {
  color: #ff6600;
  font-size: 29px;
  width: 29%;
  margin: 12px;
  border-radius: 20px;
  padding: 20px 8px;
  margin-top: 30px;
  background-color: #ffefe4;
  border: 2px solid #ff6600;
}
.an_shop2 {
  width: 40%;
  line-height: 80px;
  color: #fff;
  background-color: #ec3030;
  border-radius: 50px;
  text-align: center;
  font-size: 36px;
}
.half-angle {
    box-shadow: 1px 2px 18px 0px rgba(0, 0, 0, 0.12);
    border-radius: 40px;
}
.margin-top-sm {
    margin-top: 20px;
}
.margin-top-xs {
    margin-top: 13px;
}
.padding-top-sm {
    padding-top: 20px;
}
.padding-bottom-sm {
    padding-bottom: 20px;
}
.input1 {
  border: 0px !important;
  /* border-bottom: 1px solid #666666 !important; */
  text-align: center;
}
.oldp {
  text-decoration: line-through;
  color: #CFCFCF;
}
.text-red, .line-red, .lines-red {
    color: #e54d42;
}
.cu-form-group {
    background-color: #ffffff;
    padding: 20px 30px;
    display: flex;
    align-items: center;
    min-height: 30px;
    justify-content: space-between;
}
.picker-c {
  position: fixed;
  width: 100%;
  z-index: 999;
  bottom: 0px;
  left: 0px;
}
.picker-c2 {
  position: fixed;
  min-width: 50% !important;
  z-index: 999;
  bottom: 0px;
  left: 0px;
}
</style>
